import React from "react";
import Season from "./Seasons";

const SeasonalBackground = props => {
  return <Season {...props} />;
};

export default SeasonalBackground;
